'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../Icon/Icon.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-headline',
    cnLarge = "".concat(CLASSNAME, "--lg"),
    cnIcon = "".concat(CLASSNAME, "__icon");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function Headline(_ref) {
  var children = _ref.children,
      className = _ref.className,
      iconId = _ref.iconId,
      large = _ref.large,
      level = _ref.level;
  var classes = classNames(CLASSNAME, className, "".concat(CLASSNAME, "--").concat(level), _rollupPluginBabelHelpers.defineProperty({}, cnLarge, !level || large));
  var MyH = "h".concat(level === 0 ? 1 : level);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(MyH, {
    className: classes
  }, iconId && /*#__PURE__*/React__default.createElement(Icon, {
    className: cnIcon,
    id: iconId,
    size: level === 0 ? 'xl' : large ? 'lg' : 'md'
  }), /*#__PURE__*/React__default.createElement("span", null, children)));
}
Headline.propTypes = {
  /** Child nodes */
  children: PropTypes.node.isRequired,

  /** Additional class name */
  className: PropTypes.string,

  /** Id of icon to the left */
  iconId: PropTypes.string,

  /** True for large styling */
  large: PropTypes.bool,

  /** Level of headline e.g. 1 for h1 */
  level: PropTypes.number
};
Headline.defaultProps = {
  level: 1
};

module.exports = Headline;
